import { Divider as DefaultDivider } from "@material-ui/core";
import styled from "styled-components";

const Divider = styled(DefaultDivider)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

export default Divider;
  